import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Etage } from "src/app/models/Etage";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
  })
  export class EtageService{
    constructor(private readonly http: HttpClient){}
    BASE_PATH_BI_PLAN = "/programmes-lots/etages/etage-all";
   

    getEtagefromsource(): Observable<Etage[]>{
        //const url = environment.host.serviceProgrammesLot
        return this.http.get<Etage[]>(environment.host.domaine+this.BASE_PATH_BI_PLAN)
    }
}
